import { render, staticRenderFns } from "./SubProcesoImpresion.vue?vue&type=template&id=1b68d817&"
import script from "./SubProcesoImpresion.vue?vue&type=script&lang=js&"
export * from "./SubProcesoImpresion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports